import { render, staticRenderFns } from "./DefinitionEditModal.vue?vue&type=template&id=5a78c561"
import script from "./DefinitionEditModal.vue?vue&type=script&lang=ts"
export * from "./DefinitionEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports